const PERSON_AVATAR_DEMO_FILE_MAP: Record<string, string> = {
  邓晓彬: 'xb.png',
  郭俊玺: 'gz.png',
  黄忠鸿: 'hzh.png',
  汤大伟: 'dw.png',
  郭芸溪: 'yx.png',
  杨柳: 'yl.png',
  吴磊: 'xb.png',
  王浩: 'yx.png',
  陈杰: 'dw.png',
  杨欣: 'yl.png',
};

export function resolvePersonDemoAvatarUrls(
  name: string,
  enabled: boolean
): string[] {
  if (!enabled) {
    return [];
  }

  const fileName = PERSON_AVATAR_DEMO_FILE_MAP[name.trim()];
  if (!fileName) {
    return [];
  }

  return [`/static-files/testavatar/${fileName}`];
}

export interface PersonAvatarSources {
  avatarUrl?: string;
  avatarFallbackUrls: string[];
}

export function resolvePersonAvatarSources(
  name: string,
  apiAvatarUrl: string | undefined,
  enableDemoAvatar: boolean
): PersonAvatarSources {
  const primaryAvatarUrl = (apiAvatarUrl || '').trim();
  const demoAvatarUrls = resolvePersonDemoAvatarUrls(name, enableDemoAvatar);
  const avatarUrl = primaryAvatarUrl || demoAvatarUrls[0] || '';
  const avatarFallbackUrls = [
    ...demoAvatarUrls,
    ...(primaryAvatarUrl ? [primaryAvatarUrl] : []),
  ].filter(url => url && url !== avatarUrl);

  return {
    avatarUrl: avatarUrl || undefined,
    avatarFallbackUrls,
  };
}
